import { useAzureFiltersSearch } from './use-azure-filters-search.hook';
import { IConfig } from '@vivli/shared/infrastructure/interface';

export const useFiltersSearch = (config: IConfig) => {
    return useAzureFiltersSearch({
        config,
        indexName: 'studies'
    });
};
